import { useId } from 'react'
import { useTranslation } from 'react-i18next'

import { ChatModal } from './chat-modal'

interface ChatConfirmDialogProps {
  open: boolean
  titleKey: string
  bodyKey: string
  confirmLabelKey: string
  busy?: boolean
  onCancel: () => void
  onConfirm: () => void
}

/**
 * Destructive confirmation shared by chat deletion actions. There is no undo
 * endpoint in the frozen contract, so the confirmation is the irreversible
 * step and the copy explains exactly what is removed and for whom.
 */
export function ChatConfirmDialog({
  open,
  titleKey,
  bodyKey,
  confirmLabelKey,
  busy = false,
  onCancel,
  onConfirm,
}: ChatConfirmDialogProps) {
  const { t } = useTranslation()
  const bodyId = useId()

  return (
    <ChatModal
      open={open}
      onClose={onCancel}
      titleKey={titleKey}
      role="alertdialog"
      describedBy={bodyId}
      centered
      footer={
        <div className="flex flex-wrap justify-end gap-2">
          <button
            type="button"
            className="btn-ghost min-h-11"
            onClick={onCancel}
            disabled={busy}
          >
            {t('common.cancel')}
          </button>
          <button
            type="button"
            className="chat-btn-danger"
            onClick={onConfirm}
            disabled={busy}
            aria-busy={busy}
          >
            {t(confirmLabelKey)}
          </button>
        </div>
      }
    >
      <p id={bodyId} className="text-muted">
        {t(bodyKey)}
      </p>
    </ChatModal>
  )
}
